//#region Libraries
//#endregion
//#region Styles
import {
    Container, 
    Title } from "../../../styles";
import {
    Content, 
    FieldsGroup } from "./styles";    
//#endregion
//#region Components
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
import { Row } from "components/styles";
//#endregion
//#region Utils
import { handlerKeyPressOnlyNumbersAndLetters } from "utils/validations";
//#endregion

const LocationPlaceStep2InCampus = ({
    form, errors, 
    changeField, as
}) => {
    const { envName, address, floor } = form;
    //#region States
    //#endregion
    //#region Functions
    const changeEnvironmentName = value => {
        changeField("envName", value, false);
    }
    const changeEnvironmentFloor = value => {
        changeField("floor", value, false);
    }
    //#endregion
    return (
        <Container>
            <Title>Paso 02:</Title>
            <Content>
                <section>
                    <h4>Dentro del Campus UTP</h4>
                    <FieldsGroup width="100%">
                        <Row minWidth="200px" maxWidth="500px">
                            <CustomTextInput
                                label="Ambiente"
                                value={envName}
                                onChange={changeEnvironmentName}
                                placeholder="Ejemplo: Cancha 1 Innova School"
                                maxLength={250}
                                error={errors.envName}
                                errorText={`Escribe el ambiente para el ${as}`}/>
                            <CustomTextInput
                                label="Dirección"
                                value={address}
                                placeholder="Dirección del ambiente"
                                disabled/>
                            <CustomTextInput
                                label="Piso"
                                value={floor}
                                onChange={changeEnvironmentFloor}
                                onKeyPress={handlerKeyPressOnlyNumbersAndLetters}
                                placeholder="Agregar piso"
                                maxLength={100}
                                error={errors.floor}
                                errorText={`Escribe el piso para el ${as}`}/>
                        </Row>
                    </FieldsGroup>
                </section>
            </Content>
        </Container>
    );
}

export default LocationPlaceStep2InCampus;